import GenericAjaxService from './GenericAjaxService';
import {privateAPI} from './api';
export default class SpsCallibration extends GenericAjaxService {
  static validateSPSLogin(opts){
    return super.getAPI(privateAPI, `spsCallibration/accessSPSCal`, opts);
  }
}